import script from "./icon-wallet.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-wallet.vue?vue&type=script&lang=ts&setup=true"

import "./icon-wallet.vue?vue&type=style&index=0&id=7b6ce280&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b6ce280"]])

export default __exports__